import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Button, TextField } from '../../elements';
import { ContainerButton, Title, Actions, InputContainer } from './common';
import getErrorMsg from '../../helpers/errorMessages';

const HintTitle = styled.p`
  color: ${({ theme }) => theme.colors.secondary};
  margin: 27px 0 5px;
  font-size: 12px;
`;
const HintDescription = styled.p`
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 39px;
  font-size: 12px;
`;

export default function ChangePasswordForm({ onSubmit }) {
  const { handleSubmit, errors, formState, ...formControl } = useForm({
    mode: 'onChange',
  });
  const history = useHistory();

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Title color="white">Crie sua nova senha</Title>
      <InputContainer>
        <TextField
          fullWidth
          label="Sua senha *"
          name="password"
          rules={{
            required: true,
            minLength: 8,
          }}
          type="password"
          formControl={formControl}
          error={!!errors.password}
          caption={getErrorMsg(errors, 'password')}
        />
      </InputContainer>
      <TextField
        fullWidth
        name="confirmPassword"
        label="Confirme sua senha *"
        type="password"
        rules={{
          required: true,
          validate: val => val === formControl.getValues('password'),
          minLength: 8,
        }}
        formControl={formControl}
        error={!!errors.confirmPassword}
        caption={getErrorMsg(errors, 'confirmPassword')}
      />
      <HintTitle>Dica de senha</HintTitle>
      <HintDescription>
        Crie uma senha com no minimo 8 caracteres. Evite senhas fáceis de
        adivinhar.
      </HintDescription>
      <Actions>
        <Button
          label="Alterar senha"
          type="submit"
          variant="contained"
          disabled={!formState.isValid}
        />
        <ContainerButton>
          <Button
            label="Cancelar"
            onClick={() => history.push('/login')}
            variant="transparent"
          />
        </ContainerButton>
      </Actions>
    </form>
  );
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func,
};
